/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_SeriesInputs */

const en_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesson Series`)
};

const es_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series de lecciones`)
};

const de_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterrichtsreihe`)
};

const zh_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系列课程`)
};

const ar_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلسلة دروس`)
};

const fr_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série de leçons`)
};

const vi_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuỗi bài học`)
};

const sw_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mfululizo wa Masomo`)
};

const th_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชุดบทเรียน`)
};

const bs_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serije lekcija`)
};

const ja_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンシリーズ`)
};

const ko_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 시리즈`)
};

const pt_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacotes de aulas`)
};

const it_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie di lezioni`)
};

const sv_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektionsserier`)
};

const nl_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesreeks`)
};

const da_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektionsserie`)
};

const nb_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leksjonsserie`)
};

const fi_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppituntisarja`)
};

const pl_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seria lekcji`)
};

const ru_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Серии уроков`)
};

const tr_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders Serisi`)
};

const hi_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ शृंखला`)
};

const id_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seri Pelajaran`)
};

const ms_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siri Pelajaran`)
};

const cs_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série lekcí`)
};

const el_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σειρά μαθημάτων`)
};

const he_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סדרת שיעורים`)
};

const af_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesreeks`)
};

const hu_prices_series = /** @type {(inputs: Prices_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Órasorozat`)
};

/**
* | output |
* | --- |
* | "Lesson Series" |
*
* @param {Prices_SeriesInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_series = /** @type {((inputs?: Prices_SeriesInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_SeriesInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_series(inputs)
	if (locale === "de") return de_prices_series(inputs)
	if (locale === "zh") return zh_prices_series(inputs)
	if (locale === "ar") return ar_prices_series(inputs)
	if (locale === "fr") return fr_prices_series(inputs)
	if (locale === "vi") return vi_prices_series(inputs)
	if (locale === "sw") return sw_prices_series(inputs)
	if (locale === "th") return th_prices_series(inputs)
	if (locale === "bs") return bs_prices_series(inputs)
	if (locale === "ja") return ja_prices_series(inputs)
	if (locale === "ko") return ko_prices_series(inputs)
	if (locale === "pt") return pt_prices_series(inputs)
	if (locale === "it") return it_prices_series(inputs)
	if (locale === "sv") return sv_prices_series(inputs)
	if (locale === "nl") return nl_prices_series(inputs)
	if (locale === "da") return da_prices_series(inputs)
	if (locale === "nb") return nb_prices_series(inputs)
	if (locale === "fi") return fi_prices_series(inputs)
	if (locale === "pl") return pl_prices_series(inputs)
	if (locale === "ru") return ru_prices_series(inputs)
	if (locale === "tr") return tr_prices_series(inputs)
	if (locale === "hi") return hi_prices_series(inputs)
	if (locale === "id") return id_prices_series(inputs)
	if (locale === "ms") return ms_prices_series(inputs)
	if (locale === "cs") return cs_prices_series(inputs)
	if (locale === "el") return el_prices_series(inputs)
	if (locale === "he") return he_prices_series(inputs)
	if (locale === "af") return af_prices_series(inputs)
	if (locale === "hu") return hu_prices_series(inputs)
	return en_prices_series(inputs)
});